// ─────────────────────────────────────────────────────────────────────────────
// AdminRoles tab — role × permission-module matrix. Display only: the backend
// hardcodes these definitions and exposes no save endpoint.
// ─────────────────────────────────────────────────────────────────────────────
import panes from "./panes.module.css";
import styles from "./AdminRoles.module.css";
import { useAdminRoles } from "../hooks/useAdminRoles";
import {
  PERMISSION_MODULES, ACCESS_LEVEL_CONFIG, ROLE_COLORS,
} from "../../../services/settingsService";
import { SectionTitle, SectionSub, LoadingPane, ErrorBanner } from "./fields";

export default function AdminRoles() {
  const { roles, loading, error } = useAdminRoles();

  if (loading) return <LoadingPane/>;
  if (error)   return <ErrorBanner>{error}</ErrorBanner>;

  return (
    <div className={`${panes.pane} ${panes.paneWide}`}>
      <SectionTitle>Admin Roles</SectionTitle>
      <SectionSub>
        Role definitions are managed at the platform level. Contact support to request changes.
      </SectionSub>

      <div className={styles.table}>
        <div className={styles.head}>
          <span className={styles.colName}>Role</span>
          {PERMISSION_MODULES.map(m => (
            <span key={m.key} className={styles.colPerm}>{m.label}</span>
          ))}
        </div>

        {roles.map(role => (
          <div key={role.role} className={styles.row}>
            <div className={styles.info}>
              <span className={styles.name}
                style={{ color: ROLE_COLORS[role.role] || "var(--text-primary)" }}>
                {role.role}
              </span>
              <span className={styles.desc}>{role.description}</span>
            </div>

            {PERMISSION_MODULES.map(m => {
              const level = role.permissions?.[m.key] ?? "none";
              const cfg   = ACCESS_LEVEL_CONFIG[level] ?? ACCESS_LEVEL_CONFIG.none;
              return (
                <div key={m.key} className={styles.colPerm}>
                  <span className={styles.pill} style={{
                    color:       cfg.color,
                    background:  cfg.color + "18",
                    borderColor: cfg.color + "44",
                  }}>
                    {cfg.label}
                  </span>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
